class CountryDestinationService {

    GetContent() {
        let response = window.__pt.destinationdatacountry;





        if (response) {


            const groupedState = response.similarDestination.reduce((acc, destination) => {
                const stateName = destination.stateName;
                if (!acc[stateName]) {
                    acc[stateName] = [];
                }
                acc[stateName].push(destination);
                return acc;
            }, {});

           
            
            const data = Object.entries(groupedState);

            
            const midIndex = Math.floor(data.length / 2);
            const firstHalfDestinatiions = data.slice(0, midIndex);
            const secondHalfDestinatiions = data.slice(midIndex);


            return { response,firstHalfDestinatiions, secondHalfDestinatiions };
        }

        return {
            firstHalf: [],
            secondHalf: [],
            message: null,
            status: 404
        }
    }
}

export const CountryDestinationServices = new CountryDestinationService();